import React from 'react'
import { useTranslation } from 'react-i18next'
import {Collapse as AntCollapse, Form, Radio} from 'antd'
import {observer} from 'mobx-react'
import {Collapse, Input, Select} from '@/components'
import {AccountTransactionsFilterFormProps} from './props'
import styles from './styles.scss'
import {
    ACCOUNT,
    BALANCE,
    CHANNEL,
    DEBIT_CREDIT,
    LOAD_AFTER,
    MERCHANT,
    MERCHANT_ITEM,
    OTP_CODE,
    REFERENCE,
    TYPE,
    USER
} from '@/constants/playwright-ids'

const {Panel} = AntCollapse

export const AccountTransactionsFilterForm: React.FC<AccountTransactionsFilterFormProps> = observer(
    ({formId, form, selectTransactionTypes, selectDebitCredit, onFinish}) => {
        const { t } = useTranslation()
        return (
            <Form id={formId} form={form} onFinish={onFinish}>
                <Collapse>
                    <Panel className={styles.panel} header={t('AccountTransactionsFilterForm.type')} key='0'>
                        <Form.Item className={styles.formItem} name='type'>
                            <Select
                                className={styles.select}
                                variant={'borderless'}
                                data-test-id={TYPE}
                                options={selectTransactionTypes}
                                placeholder={t('AccountTransactionsFilterForm.type')}
                            />
                        </Form.Item>
                    </Panel>
                    <Panel className={styles.panel} header={t('AccountTransactionsFilterForm.code')} key='1'>
                        <Form.Item className={styles.formItem} name={'code'}>
                            <Input
                                className={styles.input}
                                data-test-id={OTP_CODE}
                                placeholder={t('AccountTransactionsFilterForm.code')}
                            />
                        </Form.Item>
                    </Panel>
                    <Panel className={styles.panel} header={t('AccountTransactionsFilterForm.channel')} key='2'>
                        <Form.Item className={styles.formItem} name='channel'>
                            <Input
                                className={styles.input}
                                data-test-id={CHANNEL}
                                placeholder={t('AccountTransactionsFilterForm.channel')}
                            />
                        </Form.Item>
                    </Panel>
                    <Panel className={styles.panel} header={t('AccountTransactionsFilterForm.merchant')} key='3'>
                        <Form.Item className={styles.formItem} name='merchant'>
                            <Input
                                className={styles.input}
                                data-test-id={MERCHANT}
                                placeholder={t('AccountTransactionsFilterForm.merchant')}
                            />
                        </Form.Item>
                    </Panel>
                    <Panel className={styles.panel} header={t('AccountTransactionsFilterForm.user')} key='4'>
                        <Form.Item className={styles.formItem} name='user'>
                            <Input
                                className={styles.input}
                                data-test-id={USER}
                                placeholder={t('AccountTransactionsFilterForm.user')}
                            />
                        </Form.Item>
                    </Panel>
                    <Panel className={styles.panel} header={t('AccountTransactionsFilterForm.reference')} key='5'>
                        <Form.Item className={styles.formItem} name='reference'>
                            <Input
                                className={styles.input}
                                data-test-id={REFERENCE}
                                placeholder={t('AccountTransactionsFilterForm.reference')}
                            />
                        </Form.Item>
                    </Panel>
                    <Panel className={styles.panel} header={t('AccountTransactionsFilterForm.showHidden')} key='6'>
                        <Form.Item className={styles.formItem} name='showHidden'>
                            <Radio.Group value={true} buttonStyle='solid'>
                                <Radio key={'yes'} value={true}>
                                    {t('AccountTransactionsFilterForm.yes')}
                                </Radio>
                                <Radio key={'no'} value={false}>
                                    {t('AccountTransactionsFilterForm.no')}
                                </Radio>
                            </Radio.Group>
                        </Form.Item>
                    </Panel>
                    <Panel className={styles.panel} header={t('AccountTransactionsFilterForm.account')} key='7'>
                        <Form.Item className={styles.formItem} name='account'>
                            <Input
                                className={styles.input}
                                data-test-id={ACCOUNT}
                                placeholder={t('AccountTransactionsFilterForm.account')}
                            />
                        </Form.Item>
                    </Panel>
                    <Panel className={styles.panel} header={t('AccountTransactionsFilterForm.balance')} key='8'>
                        <Form.Item className={styles.formItem} name='balance'>
                            <Input
                                className={styles.input}
                                data-test-id={BALANCE}
                                placeholder={t('AccountTransactionsFilterForm.balance')}
                            />
                        </Form.Item>
                    </Panel>
                    <Panel
                        className={styles.panel}
                        header={t('AccountTransactionsFilterForm.transactionDirection')}
                        key='9'
                    >
                        <Form.Item className={styles.formItem} name='debitCredit'>
                            <Select
                                className={styles.select}
                                variant={'borderless'}
                                data-test-id={DEBIT_CREDIT}
                                options={selectDebitCredit}
                                placeholder={t('AccountTransactionsFilterForm.transactionDirection')}
                            />
                        </Form.Item>
                    </Panel>
                    <Panel className={styles.panel} header={t('AccountTransactionsFilterForm.loadAfter')} key='10'>
                        <Form.Item className={styles.formItem} name='loadAfter'>
                            <Input
                                className={styles.input}
                                data-test-id={LOAD_AFTER}
                                placeholder={t('AccountTransactionsFilterForm.loadAfter')}
                            />
                        </Form.Item>
                    </Panel>
                </Collapse>
            </Form>
        )
    }
)
